// The SPA always calls the API at the same-origin path `/api` - CloudFront
// routes `/api/*` to API Gateway in prod; Vite proxies it to :8001 locally.
export const apiBaseUrl = '/api';
